(function () {
  function initMobileDrawer() {
    const root = document.querySelector('[data-cirkul-header]');
    if (!root) return;

    const drawer = root.querySelector('[data-cirkul-drawer]');
    const openButton = root.querySelector('[data-cirkul-drawer-open]');
    const closeButtons = root.querySelectorAll('[data-cirkul-drawer-close]');
    if (!drawer || !openButton) return;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('cirkul-drawer-open', open);
      document.body.classList.toggle('cirkul-drawer-open', open);
    }

    openButton.addEventListener('click', function () {
      setOpen(true);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initAnnouncement() {
    const root = document.querySelector('[data-cirkul-announcement]');
    if (!root) return;

    const items = Array.from(root.querySelectorAll('[data-cirkul-announcement-item]'));
    const prev = root.querySelector('[data-cirkul-announcement-prev]');
    const next = root.querySelector('[data-cirkul-announcement-next]');
    if (items.length < 2) return;

    let index = items.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    if (index < 0) index = 0;

    function show(nextIndex) {
      index = (nextIndex + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
      });
    }

    window.setInterval(function () {
      show(index + 1);
    }, 4500);
  }

  function initFooterCleanup() {
    const footer = document.querySelector('.cirkul-footer-rich');
    if (!footer) return;

    const socialBlock = footer.querySelector('.cirkul-footer-rich__social');
    if (socialBlock) {
      socialBlock.remove();
    }

    footer.querySelectorAll('a[href]').forEach(function (link) {
      const href = (link.getAttribute('href') || '').toLowerCase();
      if (/facebook|instagram|tiktok|youtube|twitter|x\\.com/.test(href)) {
        const item = link.closest('li');
        if (item) {
          item.remove();
        } else {
          link.remove();
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileDrawer();
    initAnnouncement();
    initFooterCleanup();
  });
})();
